import React, {useCallback, useEffect, useState} from 'react'
import BackBtn from "../../components/UI/BackBtn";
import {Badge, Button} from "react-bootstrap";
import {PlusLg} from "react-bootstrap-icons";
import Page from "../../components/_layout/Page";
import './AdminTags.less'
import MaterialTable from "material-table";
import {localization, modifyDefaultOptions} from "../../helpers/table";
import AddAdminTag from "../../components/admin/AddAdminTag";
import {RegistryTag, Tag} from "../../models/Tags";
import useAPI from "../../hooks/useAPI";
import TableAction from "../../components/strategyProject/tabs/TabResults/TableAction/TableAction";
import useToast from "../../hooks/useToast";
import TagProjectsModal from "../../components/admin/TagProjectsModal";
import {ProjectShort} from "../../models/Mng";
import TagRestrictionsModal from "../../components/admin/TagRestrictionsModal";

export default function AdminTags(){
    const api = useAPI();
    const addToast = useToast();

    const [openedAddModal, setOpenedAddModal] = useState(false);
    const [tagToEdit, setTagToEdit] = useState<number | null>(null);
    const [tags, setTags] = useState<RegistryTag[]>([]);
    const [activeProjects, setActiveProjects] = useState<ProjectShort[] | null>(null);
    const [activeRestrictions, setActiveRestrictions] = useState<Pick<Tag, 'groups' | 'users'> | null>(null);

    const getTags = useCallback(async () => {
        const tags: RegistryTag[] = await api.get('/mng/labels')
        setTags(tags)
    }, [tags]);

    const handleHideModal = useCallback(() => {
        setOpenedAddModal(false);
        setTagToEdit(null)
    }, [])

    const handleEdit = (id: number) => {
        setOpenedAddModal(true);
        setTagToEdit(id)
    }

    const handleDelete = async (id: number) => {
        const response = await api.del(`/mng/labels/${id}`);
        if(response?.id){
            addToast.success('Успешно удалено!')
        }
    }

    const handleOpenProjectsModal = async (id: number) => {
        const tag: Tag = await api.get(`/mng/labels/${id}`);
        if(tag.projs){
            setActiveProjects(tag.projs)
        }
    }

    const handleOpenRestrictionsModal = async (id: number) => {
        const tag: Tag = await api.get(`/mng/labels/${id}`);
        if(tag.id){
            setActiveRestrictions({
                groups: tag.groups,
                users: tag.users
            })
        }
    }

    useEffect(() => {
        getTags()
    }, []);


    return (
        <Page className='admin'>
            <BackBtn/>
            <div className='d-flex justify-content-between align-items-center my-4'>
                <h1 className='admin-title'>Справочник тегов</h1>
                <Button onClick={() => setOpenedAddModal(true)}>
                    <PlusLg/>
                    Добавить тег
                </Button>
            </div>
            <MaterialTable<RegistryTag>
                columns={[
                    {
                      title: 'Действ',
                      render: rowData => <TableAction>
                          <div className='d-flex flex-column gap-3'>
                              <Button onClick={() => handleEdit(rowData.id)}>Редактировать</Button>
                              <Button variant='outline-danger' onClick={() => handleDelete(rowData.id)}>Удалить</Button>
                          </div>
                      </TableAction>
                    },
                    {
                        title: 'Название тегов',
                        field: 'name'
                    },
                    {
                        title: 'Количество проектов',
                        field: 'projCount',
                        render: rowData => <span
                            onClick={() => {
                                if(rowData.projCount > 0) {
                                    handleOpenProjectsModal(rowData.id)
                                }
                            }}
                            style={rowData.projCount > 0 ? {
                                color: '#0D6EFD',
                                cursor: 'pointer'
                            } : undefined}
                        >
                            {rowData.projCount}
                        </span>
                    },
                    {
                        title: 'Видимость для пользователей',
                        field: 'hasRestrictions',
                        render: rowData => (
                            <Badge
                                style={{
                                    whiteSpace: 'normal',
                                    cursor: rowData.hasRestrictions ? 'pointer' : 'default',
                                }}
                                pill
                                bg={rowData.hasRestrictions ? 'danger' : 'success'}
                                onClick={() => {
                                    if (rowData.hasRestrictions) {
                                        handleOpenRestrictionsModal(rowData.id)
                                    }
                                }}
                            >
                                {rowData.hasRestrictions ? 'Просмотр ограничен' : 'Виден всем'}
                            </Badge>
                        ),
                    }
                ]}
                data={tags}
                options={modifyDefaultOptions({
                    filtering: false,
                    headerStyle: {
                        padding: '16px'
                    },
                    toolbar: false,
                    sorting: false
                })}
                title=''
                localization={localization}
            />
            <AddAdminTag show={openedAddModal} onHide={handleHideModal} refetchTags={getTags} tagToEdit={tagToEdit}/>
            <TagProjectsModal onHide={() => setActiveProjects(null)} projects={activeProjects}/>
            <TagRestrictionsModal onHide={() => setActiveRestrictions(null)} restrictions={activeRestrictions}/>
        </Page>
    )
}
